import { useSelector } from 'react-redux';
import Contacts from './contacts';
import dashboard from './dashboard';
import other from './other';
import packages from './package';
import super_admin from './supper-admin';
import teamPipelines from './team-pipelines';
import { getState } from '../../../redux/actions/actions';

// ==============================|| MENU ITEMS ||============================== //

// const menuItems = {
//     items: [
//         dashboard,
//         teamPipelines,
//         Contacts,
//         packages,
//         other,
//         super_admin,]
// };

const MenuItems = () => {
    const authState = useSelector((state) => state.auth.authData);
    const user = getState(authState);
  
    return user.isPackageSelect
      ? {
          items: [
            dashboard,
            teamPipelines,
            Contacts,
            packages,
            other,
            super_admin,
          ],
        }
      : { items: [dashboard,packages,super_admin] };
  };

export default MenuItems;
